module.exports = __webpack_public_path__ + "img/mad.f1ad9a23.gif";